import type { KYCState } from "./types";
import { resourceSliceFactory } from "util/resource";

const state: KYCState = resourceSliceFactory();

export const sliceToken = 'kyc';

export default state;
